export default function() {
    return [
      {
        title: "nav_menu_1_title",
        items: [
            {
                title: "nav_item_1_1_title",
                to: "/alphabets/a"
            },
            {
                title: "nav_item_1_2_title",
                to: "/groups"
            },                       
        ]
      },
      {
        title: "nav_menu_2_title",
        items: [
            {
              title: "nav_item_2_1_title",
              to: "/groups/new-signs"
            },          
            {
                title: "nav_item_2_2_title",
                to: "/featured-videos"
            },                       
        ]
      },
      {
        title: "nav_menu_3_title",
        to: "/about-us"
      },            
    ];
  }
  